<template>
    <div class="auto-help knowledge-base">
        <knowledge-nav />

        <div class="auto-help__heading knowledge-base__heading">

            <svg width="791" height="112" viewBox="0 0 791 112" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M102.209 17.7598H65.5078V117.281H36.0293V17.7598H0V-5H102.209V17.7598Z" fill="#F0F5FD" fill-opacity="0.1"/>
                <path d="M163.598 74.1133H147.641V117.281H118.163V-5H166.286C180.787 -5 192.125 -1.7806 200.299 4.6582C208.474 11.097 212.561 20.1953 212.561 31.9531C212.561 40.4635 210.825 47.5182 207.354 53.1172C203.939 58.7161 198.564 63.2513 191.229 66.7227L216.76 116.021V117.281H185.182L163.598 74.1133ZM147.641 51.3535H166.286C171.885 51.3535 176.084 49.8978 178.883 46.9863C181.739 44.0189 183.167 39.9036 183.167 34.6406C183.167 29.3776 181.739 25.2624 178.883 22.2949C176.028 19.2715 171.829 17.7598 166.286 17.7598H147.641V51.3535Z" fill="#F0F5FD" fill-opacity="0.1"/>
                <path d="M265.216 117.281H235.821V-5H265.216V117.281Z" fill="#F0F5FD" fill-opacity="0.1"/>
                <path d="M318.627 75.793V117.281H289.148V-5H337.943C347.293 -5 355.552 -3.26432 362.718 0.207031C369.941 3.6224 375.512 8.52148 379.431 14.9043C383.407 21.2311 385.394 28.4258 385.394 36.4883C385.394 48.4141 381.111 57.9603 372.545 65.127C364.034 72.2376 352.332 75.793 337.439 75.793H318.627ZM318.627 53.0332H337.943C343.654 53.0332 347.993 51.6055 350.961 48.75C353.984 45.8945 355.496 41.8633 355.496 36.6562C355.496 30.9453 353.956 26.3822 350.877 22.9668C347.797 19.5514 343.598 17.8158 338.279 17.7598H318.627V53.0332Z" fill="#F0F5FD" fill-opacity="0.1"/>
                <path d="M434.102 94.6055H485.416V117.281H404.623V-5H434.102V94.6055Z" fill="#F0F5FD" fill-opacity="0.1"/>
                <path d="M577.124 65.4629H530.764V94.6055H585.522V117.281H501.286V-5H585.69V17.7598H530.764V43.543H577.124V65.4629Z" fill="#F0F5FD" fill-opacity="0.1"/>
                <path d="M654.974 75.541H604.499V53.6211H654.974V75.541Z" fill="#F0F5FD" fill-opacity="0.1"/>
                <path d="M751.301 94.4375H710.904L703.85 117.281H672.355L717.203 -5H744.918L790.102 117.281H758.439L751.301 94.4375ZM717.959 71.6777H744.246L731.06 29.2656L717.959 71.6777Z" fill="#F0F5FD" fill-opacity="0.1"/>
            </svg>

            <div class="auto-help__heading-title knowledge-base__heading-title">
                {{$store.getters.t('facilities_auto_help_title')}}
            </div>

        </div>


        <div class="auto-help__grid knowledge-base__grid">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 col-lg-3">
                        <aside class="sidebar product--sidebar" @click="filterToggle">

                            <div class="product--sidebar-wrapper">

                                <div class="sidebar-card card--slider">
                                    <a class="card-title" href="#collapse1" role="button" data-toggle="collapse" aria-expanded="false" aria-controls="collapse1">
                                        <h4>{{$store.getters.t('facilities_filter_location')}}
                                            <span class="lnr lnr-chevron-down"></span>
                                        </h4>
                                    </a>
                                    <div class="collapse show collapsible-content" id="collapse1">
                                        <div class="card-content">
                                            <div class="form-group mt-2">
                                                <label for="city_id">{{$store.getters.t('donors_locality')}}</label>
                                                <div class="" style="position:relative;">
                                                    <input v-model="locationSearch" class="form-control city-filter" autocomplete="off" id="city_id" :placeholder="$store.getters.t('donors_start_typing_locality')"/>
                                                    <div class="search-result" v-if="locationItems.length">
                                                        <div class="city-item" v-for="location in locationItems" @click="setCityId(location)">{{location.name}}</div>
                                                    </div>
                                                    <div class="search-result" v-if="!locationItems.length && locationSearch && locationSearch !== locationSelected">
                                                        <div class="city-item">{{$store.getters.t('facilities_store_form_nothing_found')}}</div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="sidebar-card card--slider">
                                    <a class="card-title" href="#collapse2" role="button" data-toggle="collapse" aria-expanded="false" aria-controls="collapse2">
                                        <h4>{{$store.getters.t('facilities_filter_tariff')}}
                                            <span class="lnr lnr-chevron-down"></span>
                                        </h4>
                                    </a>
                                    <div class="collapse show collapsible-content" id="collapse2">
                                        <ul class="card-content">
                                            <li>
                                                <div class="custom-checkbox2">
                                                    <input type="checkbox"
                                                           :checked="chargeCategory === 'paid_for'"
                                                           @change="dynamicFilter('chargeCategory','paid_for', $event)" id="filter_paid" class="">
                                                    <label for="filter_paid">
                                                        <span class="square"></span>{{$store.getters.t('facilities_store_form_paid')}}
                                                    </label>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="custom-checkbox2">
                                                    <input type="checkbox"
                                                           :checked="chargeCategory === 'free'"
                                                           @change="dynamicFilter('chargeCategory','free', $event)" id="filter_free" class="">
                                                    <label for="filter_free">
                                                        <span class="square"></span>{{$store.getters.t('facilities_store_form_free')}}
                                                    </label>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="custom-checkbox2">
                                                    <input type="checkbox"
                                                           :checked="chargeCategory === 'cost_recovery'"
                                                           @change="dynamicFilter('chargeCategory','cost_recovery', $event)" id="filter_cost_recovery" class="">
                                                    <label for="filter_cost_recovery">
                                                        <span class="square"></span>{{$store.getters.t('facilities_store_form_cost_recovery')}}
                                                    </label>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="sidebar-card card--slider">
                                    <a class="card-title" href="#collapse3" role="button" data-toggle="collapse" aria-expanded="false" aria-controls="collapse3">
                                        <h4>{{$store.getters.t('facilities_store_form_availability')}}
                                            <span class="lnr lnr-chevron-down"></span>
                                        </h4>
                                    </a>
                                    <div class="collapse show collapsible-content" id="collapse3">
                                        <ul class="card-content">
                                            <li>
                                                <div class="custom-checkbox2">
                                                    <input type="checkbox"
                                                           :checked="range === 'city'"
                                                           @change="dynamicFilter('range','city', $event)" id="range_filter_city" class="">
                                                    <label for="range_filter_city">
                                                        <span class="square"></span>{{$store.getters.t('facilities_store_form_city')}}
                                                    </label>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="custom-checkbox2">
                                                    <input type="checkbox"
                                                           :checked="range === 'region'"
                                                           @change="dynamicFilter('range','region', $event)" id="range_filter_region" class="">
                                                    <label for="range_filter_region">
                                                        <span class="square"></span>{{$store.getters.t('facilities_store_form_region')}}
                                                    </label>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="custom-checkbox2">
                                                    <input type="checkbox"
                                                           :checked="range === 'country'"
                                                           @change="dynamicFilter('range','country', $event)" id="range_filter_country" class="">
                                                    <label for="range_filter_country">
                                                        <span class="square"></span>{{$store.getters.t('facilities_store_form_country')}}
                                                    </label>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="custom-checkbox2">
                                                    <input type="checkbox"
                                                           :checked="range === 'abroads'"
                                                           @change="dynamicFilter('range','abroads', $event)" id="range_filter_abroads" class="">
                                                    <label for="range_filter_abroads">
                                                        <span class="square"></span>{{$store.getters.t('facilities_store_form_abroad')}}
                                                    </label>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <button id="sidebar-toggle" @click.prevent="sidebarFilterToggle">
                                <svg width="23" height="15" viewBox="0 0 23 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0 0.882353C0 0.395037 0.466882 0 1.04278 0H21.8984C22.4743 0 22.9412 0.395037 22.9412 0.882353C22.9412 1.36967 22.4743 1.76471 21.8984 1.76471H1.04278C0.466882 1.76471 0 1.36967 0 0.882353Z" fill="white"/>
                                    <path d="M7.05884 9.7059C7.05884 9.21859 7.36273 8.82355 7.73757 8.82355H15.2036C15.5785 8.82355 15.8824 9.21859 15.8824 9.7059C15.8824 10.1932 15.5785 10.5883 15.2036 10.5883H7.73757C7.36273 10.5883 7.05884 10.1932 7.05884 9.7059Z" fill="white"/>
                                    <path d="M4.41187 5.2941C4.41187 4.80679 4.89809 4.41174 5.49784 4.41174H17.4435C18.0433 4.41174 18.5295 4.80679 18.5295 5.2941C18.5295 5.7814 18.0433 6.17645 17.4435 6.17645H5.49784C4.89809 6.17645 4.41187 5.7814 4.41187 5.2941Z" fill="white"/>
                                    <path d="M9.88229 13.2353C9.29761 13.2353 8.82349 13.6303 8.82349 14.1176C8.82349 14.605 9.29761 15 9.88229 15H13.0588C13.6435 15 14.1176 14.605 14.1176 14.1176C14.1176 13.6303 13.6435 13.2353 13.0588 13.2353H9.88229Z" fill="white"/>
                                </svg>
                            </button>
                        </aside>
                    </div>

                    <div class="col-md-12 col-lg-9">
                        <div class="auto-help__store knowledge-base__store">
                            <a href="/auth/login" class="btn auto-help__store-btn knowledge-base__store-btn" v-if="!user">
                                {{$store.getters.t('facilities_add_ad')}}
                            </a>
                            <button class="btn auto-help__store-btn knowledge-base__store-btn" v-else @click.prevent="showStoreForm = !showStoreForm">
                                {{$store.getters.t('facilities_add_ad')}}
                            </button>
                            <transition name="slide">
                                <store-form @storeForm="refreshList" page-type="auto-help" type="STORE" v-show="showStoreForm"/>
                            </transition>
                        </div>

                        <template v-if="!loaded">
                            <div class="auto-help__item knowledge-base__item knowledge-base__item--empty d-flex">
                                <div class="LoaderBalls">
                                    <div class="LoaderBalls__item"></div>
                                    <div class="LoaderBalls__item"></div>
                                    <div class="LoaderBalls__item"></div>
                                </div>
                            </div>
                        </template>
                        <template v-else>


                            <div v-if="list.length">
                                <div class="auto-help__item" v-for="(item, idx) in list">
                                    <card-horizontal @deleted="getAutoHelps" :facility="item" :pets="userPets" :projects="userProjects" :index="idx" :key="idx" :user="user"/>
                                </div>

                                <div class="row" v-if="pageCount > 1">
                                    <div class="col-md-12">
                                        <div class="pagination-area pull-right">
                                            <nav class="navigation pagination" role="navigation">
                                                <div class="nav-links">
                                                    <paginate
                                                        v-model="page"
                                                        :page-count="pageCount"
                                                        :click-handler="paginateClickCallback"
                                                        :prev-text="''"
                                                        :next-text="''"
                                                        :container-class="'className'"
                                                        :page-class="'page-numbers'"
                                                        :page-link-class="''"
                                                        :active-class="'current'"
                                                        :prev-class="'prev page-numbers'"
                                                        :prev-link-class="'lnr lnr-arrow-left'"
                                                        :next-class="'next page-numbers'"
                                                        :next-link-class="'lnr lnr-arrow-right'"
                                                    >
                                                    </paginate>
                                                </div>
                                            </nav>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-else>
                                <div class="auto-help__item knowledge-base__item knowledge-base__item--empty d-flex">
                                    {{$store.getters.t('facilities_list_empty')}}
                                </div>
                            </div>

                        </template>





                    </div>

                </div>
            </div>
        </div>


    </div>
</template>

<script>

import KnowledgeNav from "../KnowledgeBase/KnowledgeNav";
import StoreForm from "./StoreForm";
import CardHorizontal from "./CardHorizontal";
import {paginationScrollTo} from "../helpers/helpers";

export default {
    name: "AutoHelpFacilities",
    props: ['facilitiesData'],
    components:{
        KnowledgeNav,
        StoreForm,
        CardHorizontal
    },
    data(){
        return{
            showStoreForm: false,
            userPets: [],
            userProjects: [],
            list: [],
            page: 1,
            pageCount: 0,

            loaded: true,

            searchBy: null,

            locationSearch: null,
            locationSelected: null,
            selectedLocationId: null,
            locationItems: [],

            chargeCategory: null,
            range: null,


        }
    },

    mounted(){
        this.loaded = false

        this.getUserPetsAndProdjects()
        this.getUserPetsAndProdjects('projects')

        this.getAutoHelps()
    },

    watch:{
        list(){
            this.loaded = false
            setTimeout(()=>{
                this.loaded = true
            }, 1000)
        },

        locationSearch(value) {
            if (!value) {
                this.locationSelected = null;
                this.searchBy = null;
                this.locationItems = [];
                this.selectedLocationId = null;
                return false;
            }

            if (value !== this.locationSelected) {
                this.searchLocations();
            }
        },

        selectedLocationId() {
            this.getAutoHelps(true);
        },

        chargeCategory() {
            this.getAutoHelps(true);
        },

        range() {
            this.getAutoHelps(true);
        },

    },

    computed:{
        user(){
            return this.$store.getters.getUserData
        }
    },

    methods:{


        dynamicFilter(selfObjectParam, filter, event){

            let checked = event.target.checked

            if(!checked) return this[selfObjectParam] = null
            return this[selfObjectParam] = filter
        },

        getUserPetsAndProdjects(type = 'pets'){
            if (!this.user) return

            let url = `/api/user/pets-list`


            if(type === 'projects') url = `/api/user/projects-list`

            axios(url)
                .then(response => {
                    response = response.data

                    if(response.success){
                        if(type === 'projects') return this.userProjects = response.data
                        this.userPets = response.data
                    }

                })
                .catch()

        },

        paginateClickCallback(pageNum) {
            this.page = pageNum;

            paginationScrollTo('.auto-help__grid')

            this.getAutoHelps();
        },

        refreshList(){
            this.getAutoHelps(true)
        },

        getAutoHelps(resetPage){
            let url = `/api/facilities`

            if(resetPage){
                this.page = 1
            }


            axios(url, {
                params: {
                    page: this.page,
                    type: 'auto_help',
                    city_id: this.searchBy === 'city' ? this.selectedLocationId : null,
                    region_id: this.searchBy === 'region' ? this.selectedLocationId : null,
                    charge_category: this.chargeCategory,
                    range: this.range,
                    per_page: 5,
                }
            })
                .then(response => {
                    response = response.data

                    if(response.success){
                        this.list = response.data
                        this.page = response.meta.current_page
                        this.pageCount = response.meta.last_page


                    }

                })
                .catch(error => {
                    error = error.response.data

                    console.log(error)

                })
        },

        setCityId(location) {
            this.selectedLocationId = location.id;
            this.locationSearch = location.name;
            this.locationSelected = location.name;
            this.searchBy = location.type;
            this.locationItems = [];
        },

        searchLocations() {
            let self = this;
            let url = `/api/locations`,
                params = {
                    city_id: null,
                    region_id: null,
                    country_id: null,
                    query: self.locationSearch
                }

            axios.get(url, {params: params})
                .then(response => {
                    response = response.data;
                    if (response.success) {

                        self.locationItems = response.data



                    }
                })
                .catch((error) => {

                    error = error.response.data

                    console.log(error)

                    alert(this.$store.getters.t('common_error_reload'));
                })
        },


        sidebarFilterToggle(){
            let productFilter = document.querySelector('.product--sidebar');
            let body = document.querySelector('body');
            productFilter.classList.toggle('product-sidebar--open');
            body.classList.toggle('product-sidebar--open');
        },

        filterToggle(e){
            if(window.matchMedia("min-width: 992px").matches) return

            let filterWrapper = document.querySelector('.product--sidebar-wrapper');
            let filterBtn = document.getElementById('sidebar-toggle');

            if(!filterWrapper.contains(e.target) && !filterBtn.contains(e.target)){
                let productFilter = document.querySelector('.product--sidebar');
                let body = document.querySelector('body');

                productFilter.classList.remove('product-sidebar--open');
                body.classList.remove('product-sidebar--open');
                return;

            }

        }

    }
}
</script>

<style scoped>

</style>
